export default {
  inserted: function (el, binding, vnode) {
    gtag('event', 'img', {
      'event_category': `${binding.value}`,
      'event_label': `${el.getAttribute('alt')} - ${el.getAttribute('src')}`
    });
  }
}
